import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'onlyDigitsValue',
  standalone: false
})
export class OnlyDigitsPipe implements PipeTransform {

  constructor() { }

  transform(value: string): string {
    return value ? value.replace(/[^0-9]*/g, '') : '';
  }
}
